<template>
    <div id="sub-navigation" class="right" v-if="show">
        <div id="sub-navigation-items" class="flex">
            <div class="sub-navigation-item" v-for="(subNavigationItem, s) in navigation" :key="s">
                <span>{{ subNavigationItem }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubNavigation",
    props: {
        navigation: Array,
        show: Boolean
    }
};
</script>